<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="journalList">
        <v-data-table :headers="headers" :items="journalList" sort-by="postedDateTime desc" class="elevation-1"
          hide-default-footer disable-pagination calculate-widths mobile-breakpoint="0" dense :search="search">

          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
              </v-text-field>
              <v-btn class="ma-2" outlined to="/journal/new">
                New
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-newspaper-variant-outline theme--light"
                  style="font-size: 16px"></i>
              </v-btn>

              <v-spacer></v-spacer>


              <v-dialog v-model="dialogDelete" v-if="selectedItem" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 no-word-wrap">Are you sure you want to delete the journal entitled "{{
                    selectedItem.title }}" ?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>



            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>

          <template v-slot:item.issueDate="{ item }">
            <span style="white-space: nowrap">
              {{ formatPalmDateTime(item.issueDate) }}</span>
          </template>


          <template v-slot:no-data>
            <v-btn color="primary" @click="getJournals()"> Reset </v-btn>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import dateFunctions from "@/functions/dateFunctions";

export default {
  data: () => ({
    selectedItem: null,
    dialogDelete: false,
    journalList: null,
    search: null,
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "Journal Title",
        align: "start",
        value: "title",
      },
      {
        text: "Issue Date",
        align: "start",
        value: "issueDate",
      },
    ],
  }),
  methods: {
    formatPalmDateTime(date) {
      return dateFunctions.formatPalmDate(date);
    },
    async getJournals() {
      const getJournalRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );
      this.journalList = await serverFunctions.getPostResponse("/getAllNewsLetters", getJournalRequest);
    },
    editItem(item) {
      let path = "/journal/edit/" + item.id;
      this.$router.push(path)
    },
    deleteItem(item) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.processDelete(this.selectedItem.id);
      this.closeDelete();
    },
    async processDelete(journalId) {
      
      if (!journalId || journalId < 0) {
        return;
      }

      const deleteJournalRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        journalId
      );

      await serverFunctions.getPostResponse("/deleteNewsLetter", deleteJournalRequest);

      this.getJournal();
    
    }, close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.selectedItem = null;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.selectedItem = null;
      });
    },
  },
  beforeMount() {
    this.getJournals();
  }
};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>
